import styled from "styled-components";

export const StyledWithdrawalTabPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;
